import { tabletQuery } from '@globals/themes/themeConstants'
import Stack, { StackProps } from '@mui/material/Stack'
import useMediaQuery from '@mui/material/useMediaQuery'
import { ReactNode } from 'react'

type FormActionTrayProps = StackProps & {
  children: ReactNode | ReactNode[]
  errors?: ReactNode
  mt?: number
}

const FormActionTray: React.FC<FormActionTrayProps> = ({
  errors,
  children,
  mt = 3,
  ...restProps
}) => {
  const isTablet = useMediaQuery(tabletQuery)

  return (
    <>
      {errors}
      <Stack
        direction={isTablet ? 'column-reverse' : 'row'}
        justifyContent="flex-end"
        spacing={2}
        mt={mt}
        zIndex={1}
        {...restProps}>
        {children}
      </Stack>
    </>
  )
}

export default FormActionTray
